// extracted by mini-css-extract-plugin
module.exports = {"arrowIcon":"DeliveryTimeSlotForm-module__arrowIcon___1ftMD"};